import { FiGithub, FiLinkedin, FiMessageCircle } from "react-icons/fi";
import { profile } from "../../data/portfolio";
import styles from "./Footer.module.css";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div>
          <p className={styles.brand}>
            {profile.name.split(" ")[0]}
            <span>.</span>
          </p>
          <p className={styles.sub}>{profile.title} · {profile.experience} experience</p>
        </div>
        <div className={styles.links}>
          <a href={profile.links.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <FiLinkedin />
          </a>
          <a href={profile.links.github} target="_blank" rel="noreferrer" aria-label="GitHub">
            <FiGithub />
          </a>
          <a href={profile.links.whatsapp} target="_blank" rel="noreferrer" aria-label="WhatsApp">
            <FiMessageCircle />
          </a>
          <a href={`mailto:${profile.email}`}>Email</a>
        </div>
      </div>
      <p className={styles.copy}>© {year} {profile.name}. All rights reserved.</p>
    </footer>
  );
}
